import { Bars3BottomRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { pink } from "@mui/material/colors";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useOutsideClick from "../../hooks/useOutsideClick";
import { SocialMedia } from "../../utils/SocialMedia";
import SearchDialog from "../web_development/SearchDialog";

// import logo from "../../assets/logo-alt.png";
import logo from "../../assets/FlintLogo.png";
// import logo_white from "../../assets/flint_logo_white.jpeg";
import logo_white from "../../assets/FlintWhiteLogo1.png";

// import logo from "../../assets/flintLogoV2_2.jpg";
// import logo_white from "../../assets/flintLogoV2_1.jpg";

const Header = () => {
  const location = useLocation();
  // let Links = [

  //   { name: "Services", link: "/", id: uuidv4(), elementId: "service" },
  //   { name: "About Us", link: "/about", id: uuidv4(), elementId: "about" },
  //   // {name: 'Portfolio', link: '/portfolio', id: uuidv4(), elementId: 'portfolio'},
  //   {
  //     name: "Solutions",
  //     link: "/solution",
  //     id: uuidv4(),
  //     elementId: "solutions",
  //   },
  //   // {name: 'Blog/Insights', link: '/blog', id: uuidv4(), elementId: 'blog'},
  //   {
  //     name: "Testimonials/Reviews",
  //     link: "/reviews",
  //     id: uuidv4(),
  //     elementId: "reviews",
  //   },
  //   {
  //     name: "Contact Us",
  //     link: "/contact",
  //     id: uuidv4(),
  //     elementId: "contact",
  //   },
  //   // {name: 'FAQs', link: '/faq', id: uuidv4(), elementId: 'faq'},
  // ];

  const menu_ref = useRef();
  const products_menu_ref = useRef();
  const navigate = useNavigate();
  let [open, setOpen] = useState(false);
  let [menuOpen, setMenuOpen] = useState(false);
  let [productsMenuOpen, setProductsMenuOpen] = useState(false);
  var [isScrollAtTop, setIsScrollAtTop] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useOutsideClick(menu_ref, () => {
    if (menuOpen) {
      setMenuOpen(false);
    }
  });

  useOutsideClick(products_menu_ref, () => {
    if (productsMenuOpen) {
      setProductsMenuOpen(false);
    }
  });

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  const handleProductsMenuOpen = () => {
    setProductsMenuOpen(!productsMenuOpen);
  };

  const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
      e.currentTarget?.href.split("#")[1]
    );

    if (
      ["disclaimer", "privacy"].some((str) => location.pathname.includes(str))
    ) {
      navigate("/");
    } else if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  const openSearch = () => {
    setIsOpen(true);
  };

  window.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      setIsScrollAtTop(true);
    } else {
      setIsScrollAtTop(false);
    }
  });

  return (
    <div>
      <header
        className={`${isScrollAtTop ? null : "shadow-lg"
          } w-full fixed top-0 left-0 z-[9999]`}
      >
        <div
          className={`${isScrollAtTop && location.pathname === "/"
            ? "bg-blue-950"
            : "bg-white"
            } relative sm:flex sm:max-md:flex-col gap-10 sm:max-lg:gap-15 items-center justify-between  sm:px-10`}
        >
          <div className="block sm:flex items-center gap-7 md:max-lg:gap-1">
            {/* Logo + Text wrapper */}
            <div className="flex flex-col items-start sm:block pl-3 leading-none">
              {/* Logo */}
              <Link to="/" className="block">
                <img
                  alt=""
                  src={
                    isScrollAtTop
                      ? location.pathname === "/"
                        ? logo_white
                        : logo
                      : logo
                  }
                  className="block h-[3.2rem] sm:h-[4rem] w-auto sm:my-4 cursor-pointer"
                />
              </Link>

              {/* Mobile view text */}
              <Link
                to="/"
                className="block sm:hidden mt-[-3px] ml-[2px] leading-none pb-1"
              >
                <span
                  className={`font-notosans text-[9px] font-medium tracking-tight ${isScrollAtTop && location.pathname === "/"
                    ? "text-white/80"
                    : "text-gray-700"
                    }`}
                >
                  IT services and IT consulting
                </span>
              </Link>
            </div>

            {/* Desktop view text */}
            <div className="hidden sm:block">
              <span
                className={`font-notosans text-sm mx-3 font-bold ${isScrollAtTop && location.pathname === "/"
                  ? "text-white"
                  : "text-gray-800"
                  }`}
              >
                IT services and IT consulting
              </span>
            </div>
          </div>

          <div
            onClick={() => setOpen(!open)}
            className="absolute right-8 top-[25%] cursor-pointer lg:hidden w-7 h-7"
          >
            {open ? <XMarkIcon /> : <Bars3BottomRightIcon />}
          </div>

          <ul
            className={`lg:flex items-start lg:pb-0 pb-3 absolute lg:static md:z-auto z-[-1] left-0 w-full lg:w-auto lg:pl-0 pl-9 ${open ? "top-full" : "top-[-490px]"
              } ${isScrollAtTop && location.pathname && width > 1025 == "/"
                ? "text-white"
                : "text-gray-800"
              } ${width <= 1025
                ? "bg-white shadow-lg text-black"
                : isScrollAtTop
                  ? location.pathname == "/"
                    ? "text-white"
                    : "text-gray-800"
                  : "text-gray-800"
              }`}
          >
            <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-8 md:my-0 my-7 font-semibold"
            >
              <a onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center cursor-pointer font-notosans">
                  {/* <XIcon sx={{ fontSize: 25 }} className="mx-3" /> */}
                  <InstagramIcon
                    sx={{ color: pink[500], fontSize: 25 }}
                    className="mx-1"
                    onClick={() => SocialMedia("instagram")}
                  />
                  <FacebookIcon
                    sx={{ fontSize: 30 }}
                    color="primary"
                    className="mx-1"
                    onClick={() => SocialMedia("facebook")}
                  />
                  <LinkedInIcon
                    sx={{ fontSize: 30 }}
                    color="primary"
                    className="mx-1 text-lg"
                  />
                </span>
              </a>
            </li>

            <li
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold relative" // already has relative, good
              onClick={() => handleProductsMenuOpen()}
              ref={products_menu_ref}
            >
              <a
                // onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                id="menu-button"
                aria-expanded="true"
                aria-haspopup="true"
              >
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Products
                  <svg
                    className="-mr-1 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </a>
              {productsMenuOpen && (
                <div
                  className="absolute left-1/2 top-full transform -translate-x-1/2 z-10 mt-2 w-30 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabIndex="-1"
                >
                  <div
                    className="py-1 text-center"
                    role="menu"
                    aria-orientation="vertical"
                  >
                    <Link
                      to="/products/votersync"
                      onClick={() => setOpen(false)}
                      className="text-gray-700 px-4 py-2 text-sm hover:bg-gray-100 block"
                      role="menuitem"
                    >
                      VoterSync
                    </Link>
                    <Link
                      to="/products/transbillbook"
                      onClick={() => setOpen(false)}
                      className="text-gray-700 px-4 py-2 text-sm hover:bg-gray-100 block"
                      role="menuitem"
                    >
                      TransBillbook
                    </Link>
                    <Link
                      to="/products/ecommersedashboard"
                      onClick={() => setOpen(false)}
                      className="text-gray-700 px-4 py-2 text-sm hover:bg-gray-100 block"
                      role="menuitem"
                    >
                      E-Commerce Dashboard
                    </Link>
                  </div>
                </div>
              )}
            </li>

            <li
              data-to-scrollspy-id="solutions"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold relative"
              onClick={() => handleMenuOpen()}
              ref={menu_ref}
            >
              <a
                onClick={(e) => onPress(e)}
                id="menu-button"
                aria-expanded="true"
                aria-haspopup="true"
              >
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Services
                  <svg
                    className="-mr-1 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </a>
              {menuOpen && (
                <div
                  className="absolute left-1/2 transform -translate-x-1/2 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none
"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabIndex="-1"
                >
                  <div className="py-1" role="none">
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-0"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/web-development">Web Development</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-1"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/database-migration">Database Migration</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/bi-analytics">AI Solutions</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-management">Cloud Management</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-migration">Cloud Migration</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-consultation">Cloud Consultation</Link>
                    </span>
                  </div>
                </div>
              )}
            </li>

            <li
              data-to-scrollspy-id="about"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              {/* <a href="#about" onClick={(e) => onPress(e)}> */}
              <Link to="/about">
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  About Us
                </span>
              </Link>
              {/* </a> */}
            </li>

            {/* <li
              data-to-scrollspy-id="solutions"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#solutions" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Features
                </span>
              </a>
            </li> */}

            <li
              data-to-scrollspy-id="about"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <Link to="/career">
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Careers
                </span>
              </Link>
              {/* </a> */}
            </li>

            <li
              data-to-scrollspy-id="about"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <Link to="/contact">
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Contact
                </span>
              </Link>
            </li>

            {/* <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#reviews" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Reviews
                </span>
              </a>
            </li> */}

            {/* <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#faq" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  FAQ
                </span>
              </a>
            </li> */}

            {/* <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#contact" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Contact
                </span>
              </a>
            </li> */}

            <li
              data-to-scrollspy-id="reviews"
              className="md:ml-3 lg:my-0 md:my-7 my-5 font-semibold"
            >
              <a href="#contact" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px]  flex gap-1 items-center hover:text-blue-400 cursor-pointer font-notosans">
                  <PhoneInTalkIcon style={{ fontSize: 16 }} />
                  <div>7977954690</div>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </header>

      <SearchDialog
        isDialogOpened={isOpen}
        handleCloseDialog={() => setIsOpen(false)}
      />
    </div>
  );
};

export default Header;
